/// 数据看板客户组件
<template>
  <div class="index-box">
    <div style="margin-bottom: 0.5rem;">
      <p class="text-title">客户过程管理</p>
    </div>
    <CustomerKeyData :formState="props.formState"/>
    <a-row :gutter="8">
        <a-col :span="8">
          <!-- 客户阶段状态 -->
          <CustomerStageStatus height="300px" appId="cos_fbu" :formState="props.formState"/>
        </a-col>
        <a-col :span="8">
          <!-- 跟进及时率 -->
          <FollowInTimeRate height="300px" appId="cos_fbu" :customerRegionEmployeeNoList="props.formState.customerRegionEmployeeNoList"/>
        </a-col>
        <a-col :span="8">
          <!-- 异动整合 -->
          <AlarmPieCombine height="300px" appId="cos_fbu" :formState="props.formState"/>
        </a-col>
    </a-row>
    <a-row :gutter="8">
      <a-col :span="8">
        <!-- 成交客户分布情况 -->
        <TransactCustomerDistribution height="300px" appId="cos_fbu" :formState="props.formState"/>
      </a-col>
      <a-col :span="8">
        <!-- 客户拜访完成情况 -->
        <CustomerVisitCompletionStatus height="300px" appId="cos_fbu" :formState="props.formState"/>
      </a-col>
      <a-col :span="8">
        <!-- 异动趋势 -->
        <CustomerAlarmTrend height="300px" appId="cos_fbu" :customerRegionEmployeeNoList="props.formState.customerRegionEmployeeNoList"/>
      </a-col>
    </a-row>
<!--    <a-col :span="24">-->
<!--      &lt;!&ndash; 异动趋势 &ndash;&gt;-->
<!--      <CustomerAlarmTrend appId="cos_fbu" :employeeNo="props.employeeNo"/>-->
<!--    </a-col>-->
  </div>
</template>
<script lang="ts" setup>
import CustomerStageStatus from './componects/CustomerStageStatus.vue'
import FollowInTimeRate from './componects/FollowInTimeRate.vue'
import CustomerKeyData from './componects/CustomerKeyData.vue'
import TransactCustomerDistribution from './componects/TransactCustomerDistribution.vue'
import { PropType } from 'vue'
import CustomerAlarmTrend from './componects/CustomerAlarmTrend.vue'
import AlarmPieCombine from './componects/AlarmPieCombine.vue'
import CustomerVisitCompletionStatus from './componects/CustomerVisitCompletionStatus.vue'

const props = defineProps({
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  formState: {
    type: Object as PropType<Object>
  }
})
</script>
<script lang="ts">
export default { name: 'Tab2' }
</script>
<style scoped lang="scss">
.index-box {
  background: rgb(249, 249, 255);
  padding: 10px;
}
.text-title {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
</style>
